<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-监督员-详情
    -->
    <el-dialog
    title="监督员详情"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" label-width="100px" disabled>
      <div class="common-form">学员基本信息</div>

      <div class="detail-layout">
        <div class="left-section">
          <div class="avatar-section">
            <div v-if="form.image" class="avatar-image">
              <img :src="form.image" />
            </div>
            <div v-else class="avatar-placeholder">
              <i class="el-icon-user"></i>
            </div>
          </div>
        </div>

        <div class="right-section">
          <div class="info-row">
            <div class="info-col">
              <div class="info-item">
                <span class="label">姓名</span>
                <span class="value">{{ form.name || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">性别</span>
                <span class="value">
                  <span v-if="form.gender === '1'">男</span>
                  <span v-else-if="form.gender === '2'">女</span>
                  <span v-else>-</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">年龄</span>
                <span class="value">{{ form.birth_date ? calculateAge(form.birth_date) : '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">国籍</span>
                <span class="value">
                  <span v-if="form.nationality === '1'">中国</span>
                  <span v-else-if="form.nationality === '2'">中国香港特别行政区</span>
                  <span v-else-if="form.nationality === '3'">中国台湾</span>
                  <span v-else-if="form.nationality === '4'">中国澳门特别行政区</span>
                  <span v-else>-</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">学历</span>
                <span class="value">
                  <span v-if="form.education === '1'">小学</span>
                  <span v-else-if="form.education === '2'">初中</span>
                  <span v-else-if="form.education === '3'">高中</span>
                  <span v-else-if="form.education === '4'">大专</span>
                  <span v-else-if="form.education === '5'">本科</span>
                  <span v-else-if="form.education === '6'">硕士</span>
                  <span v-else-if="form.education === '7'">博士</span>
                  <span v-else-if="form.education === '8'">其他</span>
                  <span v-else>-</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">邮箱</span>
                <span class="value">{{ form.email || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">微信</span>
                <span class="value">{{ form.wechat || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">状态</span>
                <span class="value">
                  <el-tag v-if="form.status === '1' || form.status === 1" type="success" size="mini">离职</el-tag>
                  <el-tag v-else type="danger" size="mini">在职</el-tag>
                </span>
              </div>
              <div class="info-item">
                <span class="label">职位</span>
                <span class="value">{{ form.position || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">牌照号码</span>
                <span class="value">{{ form.license_number || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">身份</span>
                <span class="value">
                  <el-tag v-if="form.identity && form.identity.includes('1')" size="mini" style="margin-right: 5px;">安全监督员</el-tag>
                  <el-tag v-if="form.identity && form.identity.includes('2')" size="mini" style="margin-right: 5px;">质量监督员</el-tag>
                  <el-tag v-if="form.identity && form.identity.includes('3')" size="mini" style="margin-right: 5px;">环保监督员</el-tag>
                  <el-tag v-if="form.identity && form.identity.includes('4')" size="mini">消防监督员</el-tag>
                  <span v-if="!form.identity || form.identity === ''">-</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">岗位</span>
                <span class="value">{{ form.applicable_position || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">备注</span>
                <span class="value">{{ form.remark || '-' }}</span>
              </div>
            </div>

            <div class="info-col">
              <div class="info-item">
                <span class="label">身份证号</span>
                <span class="value">{{ form.id_card || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">生日</span>
                <span class="value">{{ form.birth_date || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">手机号码</span>
                <span class="value">{{ form.mobile || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">民族</span>
                <span class="value">
                  <span v-if="form.ethnicity === '1'">汉族</span>
                  <span v-else-if="form.ethnicity === '2'">蒙古族</span>
                  <span v-else-if="form.ethnicity === '3'">回族</span>
                  <span v-else-if="form.ethnicity === '4'">藏族</span>
                  <span v-else-if="form.ethnicity === '5'">维吾尔族</span>
                  <span v-else-if="form.ethnicity === '6'">苗族</span>
                  <span v-else-if="form.ethnicity === '7'">彝族</span>
                  <span v-else-if="form.ethnicity === '8'">壮族</span>
                  <span v-else-if="form.ethnicity === '9'">布依族</span>
                  <span v-else-if="form.ethnicity === '10'">朝鲜族</span>
                  <span v-else-if="form.ethnicity === '11'">满族</span>
                  <span v-else-if="form.ethnicity === '12'">侗族</span>
                  <span v-else-if="form.ethnicity === '13'">瑶族</span>
                  <span v-else-if="form.ethnicity === '14'">白族</span>
                  <span v-else-if="form.ethnicity === '15'">土家族</span>
                  <span v-else-if="form.ethnicity === '16'">哈尼族</span>
                  <span v-else-if="form.ethnicity === '17'">哈萨克族</span>
                  <span v-else-if="form.ethnicity === '18'">傣族</span>
                  <span v-else-if="form.ethnicity === '19'">黎族</span>
                  <span v-else-if="form.ethnicity === '20'">傈僳族</span>
                  <span v-else-if="form.ethnicity === '21'">佤族</span>
                  <span v-else-if="form.ethnicity === '22'">畲族</span>
                  <span v-else-if="form.ethnicity === '23'">高山族</span>
                  <span v-else-if="form.ethnicity === '24'">拉祜族</span>
                  <span v-else-if="form.ethnicity === '25'">水族</span>
                  <span v-else-if="form.ethnicity === '26'">东乡族</span>
                  <span v-else-if="form.ethnicity === '27'">纳西族</span>
                  <span v-else-if="form.ethnicity === '28'">景颇族</span>
                  <span v-else-if="form.ethnicity === '29'">柯尔克孜族</span>
                  <span v-else-if="form.ethnicity === '30'">土族</span>
                  <span v-else-if="form.ethnicity === '31'">达斡尔族</span>
                  <span v-else-if="form.ethnicity === '32'">仫佬族</span>
                  <span v-else-if="form.ethnicity === '33'">羌族</span>
                  <span v-else-if="form.ethnicity === '34'">布朗族</span>
                  <span v-else-if="form.ethnicity === '35'">撒拉族</span>
                  <span v-else-if="form.ethnicity === '36'">毛南族</span>
                  <span v-else-if="form.ethnicity === '37'">仡佬族</span>
                  <span v-else-if="form.ethnicity === '38'">锡伯族</span>
                  <span v-else-if="form.ethnicity === '39'">阿昌族</span>
                  <span v-else-if="form.ethnicity === '40'">普米族</span>
                  <span v-else-if="form.ethnicity === '41'">塔吉克族</span>
                  <span v-else-if="form.ethnicity === '42'">怒族</span>
                  <span v-else-if="form.ethnicity === '43'">乌孜别克族</span>
                  <span v-else-if="form.ethnicity === '44'">俄罗斯族</span>
                  <span v-else-if="form.ethnicity === '45'">鄂温克族</span>
                  <span v-else-if="form.ethnicity === '46'">德昂族</span>
                  <span v-else-if="form.ethnicity === '47'">保安族</span>
                  <span v-else-if="form.ethnicity === '48'">裕固族</span>
                  <span v-else-if="form.ethnicity === '49'">京族</span>
                  <span v-else-if="form.ethnicity === '50'">塔塔尔族</span>
                  <span v-else-if="form.ethnicity === '51'">独龙族</span>
                  <span v-else-if="form.ethnicity === '52'">鄂伦春族</span>
                  <span v-else-if="form.ethnicity === '53'">赫哲族</span>
                  <span v-else-if="form.ethnicity === '54'">门巴族</span>
                  <span v-else-if="form.ethnicity === '55'">珞巴族</span>
                  <span v-else-if="form.ethnicity === '56'">基诺族</span>
                  <span v-else>-</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">入职时间</span>
                <span class="value">{{ form.create_time || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">QQ</span>
                <span class="value">{{ form.qq || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">地址</span>
                <span class="value">{{ form.province_name }} {{ form.city_name }} {{ form.region_name }} {{ form.address }}</span>
              </div>
              <div class="info-item">
                <span class="label">组织名称</span>
                <span class="value">{{ form.organization_name || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">部门</span>
                <span class="value">{{ form.department || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">线路</span>
                <span class="value">{{ form.route || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="common-form">员工任职记录</div>

      <div class="table-section">
        <el-table size="small" :data="employmentRecords" border style="width: 100%" v-loading="loading">
          <el-table-column prop="company_name" label="公司名称" width="150"></el-table-column>
          <el-table-column prop="name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="position" label="岗位" width="120"></el-table-column>
          <el-table-column prop="role" label="角色" width="120"></el-table-column>
          <el-table-column prop="department" label="部门" width="120"></el-table-column>
          <el-table-column prop="identity" label="身份" width="150">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('1')" size="mini" style="margin-right: 5px;">安全监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('2')" size="mini" style="margin-right: 5px;">质量监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('3')" size="mini" style="margin-right: 5px;">环保监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('4')" size="mini">消防监督员</el-tag>
              <span v-if="!scope.row.identity || scope.row.identity === ''">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="job_title" label="职位" width="120"></el-table-column>
          <el-table-column prop="license_number" label="牌照" width="120"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1' || scope.row.status === 1" type="success" size="mini">在职</el-tag>
              <el-tag v-else type="danger" size="mini">离职</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="entry_time" label="入职时间" width="150"></el-table-column>
          <el-table-column prop="resign_time" label="离职时间" width="150"></el-table-column>
        </el-table>
      </div>

      <div class="common-form">监督员录入记录</div>

      <div class="table-section">
        <el-table size="small" :data="entryRecords" border style="width: 100%" v-loading="loading">
          <el-table-column prop="company_name" label="公司名称" width="150"></el-table-column>
          <el-table-column prop="name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="identity" label="身份" width="150">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('1')" size="mini" style="margin-right: 5px;">安全监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('2')" size="mini" style="margin-right: 5px;">质量监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('3')" size="mini" style="margin-right: 5px;">环保监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('4')" size="mini">消防监督员</el-tag>
              <span v-if="!scope.row.identity || scope.row.identity === ''">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="training_category" label="培训类别" width="120"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1' || scope.row.status === 1" type="success" size="mini">正常</el-tag>
              <el-tag v-else type="danger" size="mini">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="entry_time" label="录入时间" width="150"></el-table-column>
          <el-table-column prop="unbind_time" label="解绑时间" width="150"></el-table-column>
        </el-table>
      </div>

      <div class="common-form">账户状态变更日志</div>
      <div class="table-section">
        <el-table size="small" :data="accountStatusLogs" border style="width: 100%" v-loading="loading">
          <el-table-column prop="company_name" label="公司名称" width="150"></el-table-column>
          <el-table-column prop="name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="id_card" label="身份证号码" width="180"></el-table-column>
          <el-table-column prop="identity" label="身份" width="150">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('1')" size="mini" style="margin-right: 5px;">安全监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('2')" size="mini" style="margin-right: 5px;">质量监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('3')" size="mini" style="margin-right: 5px;">环保监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('4')" size="mini">消防监督员</el-tag>
              <span v-if="!scope.row.identity || scope.row.identity === ''">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="account_status" label="账号状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.account_status === '1' || scope.row.account_status === 1" type="success" size="mini">正常</el-tag>
              <el-tag v-else type="danger" size="mini">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="operation_time" label="操作时间" width="150"></el-table-column>
        </el-table>
      </div>

      <div class="common-form">参加的计划</div>
      <div class="filter-section">
        <el-form :inline="true" size="small">
          <el-form-item label="综合查询">
            <el-input v-model="planFilters.search" placeholder="请输入关键字" clearable style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="组织名称">
            <el-select v-model="planFilters.organization" placeholder="请选择组织" clearable style="width: 150px;">
              <el-option v-for="item in organizationList" :key="item.ma_organization_id" :label="item.name" :value="item.ma_organization_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学员分类">
            <el-select v-model="planFilters.student_category" placeholder="请选择学员分类" clearable style="width: 150px;">
              <el-option v-for="item in studentCategoryList" :key="item.ma_student_classification_id" :label="item.name" :value="item.ma_student_classification_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="培训类别">
            <el-select v-model="planFilters.training_category" placeholder="请选择培训类别" clearable style="width: 150px;">
              <el-option v-for="item in trainingCategoryList" :key="item.ma_training_category_id" :label="item.name" :value="item.ma_training_category_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业">
            <el-select v-model="planFilters.industry" placeholder="请选择行业" clearable style="width: 150px;">
              <el-option v-for="item in industryList" :key="item.ma_training_industry_id" :label="item.name" :value="item.ma_training_industry_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="培训状态">
            <el-select v-model="planFilters.training_status" placeholder="请选择培训状态" clearable style="width: 150px;">
              <el-option label="未开始" value="0"></el-option>
              <el-option label="未培训" value="1"></el-option>
              <el-option label="培训中" value="2"></el-option>
              <el-option label="学习结束，学时待审核" value="3"></el-option>
              <el-option label="学时审核不通过" value="4"></el-option>
              <el-option label="考试待审核" value="5"></el-option>
              <el-option label="考试审核不通过" value="6"></el-option>
              <el-option label="待考试" value="7"></el-option>
              <el-option label="考试未通过(补考中)" value="8"></el-option>
              <el-option label="考试通过成绩待审核" value="9"></el-option>
              <el-option label="成绩审核不通过" value="10"></el-option>
              <el-option label="培训结束(成绩审核通过)" value="11"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年月份">
            <el-date-picker v-model="planFilters.year_month" type="month" placeholder="选择年月" value-format="yyyy-MM" style="width: 150px;"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchPlans">查询</el-button>
            <el-button @click="resetPlanFilters">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-section">
        <el-table size="small" :data="planRecords" border style="width: 100%" v-loading="loading">
          <el-table-column prop="organization_name" label="组织名称" width="150"></el-table-column>
          <el-table-column prop="plan_name" label="计划名称" width="150"></el-table-column>
          <el-table-column prop="industry" label="行业" width="100">
            <template slot-scope="scope">
              <span>{{ getIndustryName(scope.row.industry) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="training_category" label="培训类别" width="100">
            <template slot-scope="scope">
              <span>{{ getTrainingCategoryName(scope.row.training_category) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="plan_mode" label="计划模式" width="100"></el-table-column>
          <el-table-column prop="plan_requirement" label="计划要求" width="150"></el-table-column>
          <el-table-column prop="completion_result" label="完成结果" width="100"></el-table-column>
          <el-table-column prop="type" label="类型" width="100"></el-table-column>
          <el-table-column prop="student_category" label="学员分类" width="100">
            <template slot-scope="scope">
              <span>{{ getStudentCategoryName(scope.row.student_category) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="training_status" label="培训状态" width="150">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.training_status === '0'" type="info" size="mini">未开始</el-tag>
              <el-tag v-else-if="scope.row.training_status === '1'" type="info" size="mini">未培训</el-tag>
              <el-tag v-else-if="scope.row.training_status === '2'" type="warning" size="mini">培训中</el-tag>
              <el-tag v-else-if="scope.row.training_status === '3'" type="warning" size="mini">学习结束，学时待审核</el-tag>
              <el-tag v-else-if="scope.row.training_status === '4'" type="danger" size="mini">学时审核不通过</el-tag>
              <el-tag v-else-if="scope.row.training_status === '5'" type="warning" size="mini">考试待审核</el-tag>
              <el-tag v-else-if="scope.row.training_status === '6'" type="danger" size="mini">考试审核不通过</el-tag>
              <el-tag v-else-if="scope.row.training_status === '7'" type="warning" size="mini">待考试</el-tag>
              <el-tag v-else-if="scope.row.training_status === '8'" type="danger" size="mini">考试未通过(补考中)</el-tag>
              <el-tag v-else-if="scope.row.training_status === '9'" type="warning" size="mini">考试通过成绩待审核</el-tag>
              <el-tag v-else-if="scope.row.training_status === '10'" type="danger" size="mini">成绩审核不通过</el-tag>
              <el-tag v-else-if="scope.row.training_status === '11'" type="success" size="mini">培训结束(成绩审核通过)</el-tag>
              <el-tag v-else type="info" size="mini">-</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button @click="viewPlanDetail(scope.row)" type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">关闭</el-button>
    </div>
  </div>
</el-dialog>
  
</template>

<script>
import Ma_supervisorApi from '@/api/ma_supervisor.js';
import Ma_organizationApi from '@/api/ma_organization.js';
import Ma_training_categoryApi from '@/api/ma_training_category.js';
import Ma_training_industryApi from '@/api/ma_training_industry.js';
import Ma_student_classificationApi from '@/api/ma_student_classification.js';

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        code: 'custom',
        id_card: '',
        gender: '',
        birth_date: '',
        nationality: '',
        ethnicity: '',
        education: '',
        phone: '',
        password: '',
        auto_generate_account: false,
        use_default_password: false,
        mobile: '',
        license_number: '',
        applicable_position: '',
        position: '',
        department: '',
        registration_photo: '',
        remark: '',
        employee_identity: '',
        organization: '',
        organization_name: '',
        identity: [],
        qq: '',
        wechat: '',
        email: '',
        province_name: '',
        city_name: '',
        region_name: '',
        province_id: 0,
        city_id: 0,
        region_id: 0,
        address: '',
        payment_type: '',
        route: '',
        sort: 50,
      },
      loading: false,
      employmentRecords: [],
      entryRecords: [],
      accountStatusLogs: [],
      planFilters: {
        search: '',
        organization: '',
        student_category: '',
        training_category: '',
        industry: '',
        training_status: '',
        year_month: ''
      },
      planRecords: [],
      organizationList: [],
      trainingCategoryList: [],
      industryList: [],
      studentCategoryList: [],
    };
  },
  props: ["open_detail","ma_supervisor_id"],
  created() {
    this.dialogVisible = this.open_detail;
    this.getDetail();
    this.getOrganizationList();
    this.getTrainingCategoryList();
    this.getIndustryList();
    this.getStudentCategoryList();
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },

    /*计算年龄*/
    calculateAge(birthDate) {
      if (!birthDate) return '-';
      const birth = new Date(birthDate);
      const today = new Date();
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age + '岁';
    },

    getDetail() {
      let self = this;
      Ma_supervisorApi.detail({ma_supervisor_id: self.ma_supervisor_id},true).then(res => {
          self.form = res.data;
          if (!self.form.identity) {
            self.form.identity = [];
          } else {
            if (typeof self.form.identity === 'string') {
              self.form.identity = self.form.identity.split(',');
            }
          }
          if (!self.form.id_card) {
            self.form.id_card = '';
          }
          if (!self.form.gender) {
            self.form.gender = '';
          }
          if (!self.form.birth_date) {
            self.form.birth_date = '';
          }
          if (!self.form.nationality) {
            self.form.nationality = '';
          }
          if (!self.form.ethnicity) {
            self.form.ethnicity = '';
          }
          if (!self.form.education) {
            self.form.education = '';
          }
          if (!self.form.phone) {
            self.form.phone = '';
          }
          if (!self.form.password) {
            self.form.password = '';
          }
          if (!self.form.auto_generate_account) {
            self.form.auto_generate_account = false;
          }
          if (!self.form.use_default_password) {
            self.form.use_default_password = false;
          }
          if (!self.form.mobile) {
            self.form.mobile = '';
          }
          if (!self.form.license_number) {
            self.form.license_number = '';
          }
          if (!self.form.applicable_position) {
            self.form.applicable_position = '';
          }
          if (!self.form.department) {
            self.form.department = '';
          }
          if (!self.form.image) {
            self.form.image = '';
          }
          if (!self.form.remark) {
            self.form.remark = '';
          }
          if (!self.form.position) {
            self.form.position = '';
          }
          if (!self.form.employee_identity) {
            self.form.employee_identity = '';
          }
          if (!self.form.payment_type) {
            self.form.payment_type = '';
          }
          if (!self.form.route) {
            self.form.route = '';
          }
          if (!self.form.qq) {
            self.form.qq = '';
          }
          if (!self.form.wechat) {
            self.form.wechat = '';
          }
          if (!self.form.email) {
            self.form.email = '';
          }
          if (!self.form.province_name) {
            self.form.province_name = '';
          }
          if (!self.form.city_name) {
            self.form.city_name = '';
          }
          if (!self.form.region_name) {
            self.form.region_name = '';
          }
          if (!self.form.province_id) {
            self.form.province_id = 0;
          }
          if (!self.form.city_id) {
            self.form.city_id = 0;
          }
          if (!self.form.region_id) {
            self.form.region_id = 0;
          }
          if (!self.form.address) {
            self.form.address = '';
          }
          if (self.form.employment_records && Array.isArray(self.form.employment_records)) {
            self.employmentRecords = self.form.employment_records;
          } else {
            self.employmentRecords = [];
          }
          if (self.form.entry_records && Array.isArray(self.form.entry_records)) {
            self.entryRecords = self.form.entry_records;
          } else {
            self.entryRecords = [];
          }
          if (self.form.account_status_logs && Array.isArray(self.form.account_status_logs)) {
            self.accountStatusLogs = self.form.account_status_logs;
          } else {
            self.accountStatusLogs = [];
          }
          if (self.form.plan_records && Array.isArray(self.form.plan_records)) {
            self.planRecords = self.form.plan_records;
          } else {
            self.planRecords = [];
          }
          self.loading = false;
        })
        .catch(error => {});
    },

    /*查询计划*/
    searchPlans() {
      let self = this;
      self.loading = true;
      Ma_supervisorApi.getPlanRecords({
        ma_supervisor_id: self.ma_supervisor_id,
        ...self.planFilters
      }, true).then(res => {
        if (res.data && Array.isArray(res.data)) {
          self.planRecords = res.data;
        } else {
          self.planRecords = [];
        }
        self.loading = false;
      }).catch(error => {
        self.loading = false;
      });
    },

    /*获取组织列表*/
    getOrganizationList() {
      let self = this;
      Ma_organizationApi.list({}, true).then(res => {
        if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
          self.organizationList = res.data.list.data;
        } else if (res.data && Array.isArray(res.data.list)) {
          self.organizationList = res.data.list;
        } else if (res.data && Array.isArray(res.data)) {
          self.organizationList = res.data;
        } else {
          self.organizationList = [];
        }
      }).catch(error => {
        self.organizationList = [];
      });
    },

    /*获取培训类别列表*/
    getTrainingCategoryList() {
      let self = this;
      Ma_training_categoryApi.list({}, true).then(res => {
        if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
          self.trainingCategoryList = res.data.list.data;
        } else if (res.data && Array.isArray(res.data.list)) {
          self.trainingCategoryList = res.data.list;
        } else if (res.data && Array.isArray(res.data)) {
          self.trainingCategoryList = res.data;
        } else {
          self.trainingCategoryList = [];
        }
      }).catch(error => {
        self.trainingCategoryList = [];
      });
    },

    /*获取行业列表*/
    getIndustryList() {
      let self = this;
      Ma_training_industryApi.list({}, true).then(res => {
        if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
          self.industryList = res.data.list.data;
        } else if (res.data && Array.isArray(res.data.list)) {
          self.industryList = res.data.list;
        } else if (res.data && Array.isArray(res.data)) {
          self.industryList = res.data;
        } else {
          self.industryList = [];
        }
      }).catch(error => {
        self.industryList = [];
      });
    },

    /*获取学员分类列表*/
    getStudentCategoryList() {
      let self = this;
      Ma_student_classificationApi.list({}, true).then(res => {
        if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
          self.studentCategoryList = res.data.list.data;
        } else if (res.data && Array.isArray(res.data.list)) {
          self.studentCategoryList = res.data.list;
        } else if (res.data && Array.isArray(res.data)) {
          self.studentCategoryList = res.data;
        } else {
          self.studentCategoryList = [];
        }
      }).catch(error => {
        self.studentCategoryList = [];
      });
    },

    /*获取培训类别名称*/
    getTrainingCategoryName(id) {
      if (!id) return '-';
      const item = this.trainingCategoryList.find(item => item.ma_training_category_id == id);
      return item ? item.name : '-';
    },

    /*获取行业名称*/
    getIndustryName(id) {
      if (!id) return '-';
      const item = this.industryList.find(item => item.ma_training_industry_id == id);
      return item ? item.name : '-';
    },

    /*获取学员分类名称*/
    getStudentCategoryName(id) {
      if (!id) return '-';
      const item = this.studentCategoryList.find(item => item.ma_student_classification_id == id);
      return item ? item.name : '-';
    },

    /*重置筛选条件*/
    resetPlanFilters() {
      this.planFilters = {
        search: '',
        organization: '',
        student_category: '',
        training_category: '',
        industry: '',
        training_status: '',
        year_month: ''
      };
      this.searchPlans();
    },

    /*查看计划详情*/
    viewPlanDetail(row) {
      this.$message.info('查看计划详情功能待实现');
    },
  }
}
</script>

<style>
.detail-layout {
  display: flex;
  gap: 20px;
}

.left-section {
  flex-shrink: 0;
}

.right-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.info-row {
  display: flex;
  gap: 40px;
}

.info-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-item .label {
  color: #909399;
  font-size: 14px;
  width: 80px;
  flex-shrink: 0;
}

.info-item .value {
  color: #303133;
  font-size: 14px;
  flex: 1;
}

.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.avatar-image {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
}

.avatar-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  color: #c0c4cc;
  border: 1px solid #dcdfe6;
}

.table-section {
  margin-top: 20px;
}

.img-list {
  display: flex;
  align-items: center;
}

.img-list .item {
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.img-list .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-list .item .hide-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.img-list .item.upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  cursor: pointer;
}

.img-list .item.upload-btn:hover {
  background: #e6e8eb;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_supervisor/index/part/detail.vue